import { useState } from "react";
import { downloadReportCustomerStatus } from "../../api/finance";
import AlertBox from "../../components/AlertBox";
import Box from "../../components/Box";
import MainLayout from "../../components/layouts/MainLayout";
import { useControlPermission } from "../../utils/ActionPermissionUtils";
import { useReportCustomerStatus } from "../../utils/finance/ReportBillingUtils";
import { convertDecimalToComma, parseToIndoNumber } from "../../tools/numerictools";
import { useAllPartnersHooks } from "../../utils/project/PartnerUtils";

export default function ReportCustomerStatus() {
  const { hasAccess } = useControlPermission();
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const { partners } = useAllPartnersHooks();

  const [formFilter, setFormFilter] = useState({
    partner_id: "",
  });

  const [filter, setFilter] = useState({
    partner_id: "",
  });

  const changeFilter = (name, value) => {
    setFormFilter({ ...formFilter, [name]: value });
  };

  const { projects, meta, loading, errorMsg } = useReportCustomerStatus({ filter });

  const onSuccess = (message) => {
    setAlert({ show: true, message, type: "success" });
  };

  const onError = (message) => {
    setAlert({ show: true, message, type: "danger" });
  };

  function applyFilter() {
    let form_filter = {
      ...filter,
      ...formFilter,
      page: 1,
    };
    setFilter(form_filter);
  }

  const resetFilter = () => {
    setFormFilter({
      partner_id: "",
    });
    setFilter({
      partner_id: "",
    });
  };

  return (
    <MainLayout resource_key="manage-customer">
      <div className="container-fluid">
        <h1 className="h3 mb-4 text-gray-800">Laporan Jumlah Pelanggan</h1>
        <Box title="Laporan Status Pelanggan" loading={loading}>
          {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
          <AlertBox {...alert} setAlert={setAlert} />
          <div className="row">
            <div className="col-md-2">
              <div className="form-group">
                <label htmlFor="partnerFilter">Mitra</label>
                <select
                  className="form-control"
                  id="partnerFilter"
                  value={formFilter.partner_id}
                  onChange={(event) => changeFilter("partner_id", event.target.value)}
                >
                  <option value="">SEMUA</option>
                  {partners.map((partner, index) => (
                    <option key={index} value={partner.id}>
                      {partner.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-auto">
              <button
                className="btn btn-primary"
                onClick={() => applyFilter()}
                style={{ marginTop: "32px" }}
              >
                Filter
              </button>
              <button
                className="btn btn-default"
                onClick={() => resetFilter()}
                style={{ marginTop: "32px" }}
              >
                Reset
              </button>
            </div>
            <div className="col-12 col-md-auto ml-auto" style={{ paddingTop: "32px" }}>
              {hasAccess("export-customer-status-report") && (
                <ButtonDownloadReport filter={filter} onSuccess={onSuccess} onError={onError} />
              )}
            </div>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table className="table table-bordered table-striped table-hover">
              <thead>
                <tr>
                  <th>Project/Grup</th>
                  <th>Mitra</th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Aktif
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Aktif Trial
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Isolir
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Deaktivasi Isolir
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Total Pelanggan Aktif
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Dismantle
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Dismantle Trial
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Reaktivasi
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Total Pelanggan
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Total Homepass
                  </th>
                  <th className="text-center" style={{ width: "100px" }}>
                    Take Up Rate
                  </th>
                </tr>
              </thead>
              <tbody>
                {projects.length === 0 ? (
                  <tr>
                    <td colSpan={14} className="text-center">
                      Tidak ada data
                    </td>
                  </tr>
                ) : null}
                {projects.map((project, index) => (
                  <tr key={index}>
                    <td>{project.project || "-"}</td>
                    <td>{project.partner || "-"}</td>
                    <td className="text-right">{parseToIndoNumber(project.active)}</td>
                    <td className="text-right">{parseToIndoNumber(project.active_trial)}</td>
                    <td className="text-right">{parseToIndoNumber(project.inactive)}</td>
                    <td className="text-right">{parseToIndoNumber(project.deactivate_inactive)}</td>
                    <td className="text-right">{parseToIndoNumber(project.installed)}</td>
                    <td className="text-right">{parseToIndoNumber(project.dismantled)}</td>
                    <td className="text-right">{parseToIndoNumber(project.dismantled_trial)}</td>
                    <td className="text-right">{parseToIndoNumber(project.reactivated)}</td>
                    <td className="text-right">{parseToIndoNumber(project.total)}</td>
                    <td className="text-right">{parseToIndoNumber(project.homepass)}</td>
                    <td className="text-right">{convertDecimalToComma(project.occupation_rate)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="text-right" colSpan={2}>
                    <b>Total</b>
                  </td>
                  <td className="text-right font-weight-bold">
                    {parseToIndoNumber(meta.total_active)}
                  </td>
                  <td className="text-right font-weight-bold">
                    {parseToIndoNumber(meta.total_active_trial)}
                  </td>
                  <td className="text-right font-weight-bold">
                    {parseToIndoNumber(meta.total_inactive)}
                  </td>
                  <td className="text-right font-weight-bold">
                    {parseToIndoNumber(meta.total_deactivate_inactive)}
                  </td>
                  <td className="text-right font-weight-bold">
                    {parseToIndoNumber(meta.total_installed || 0)}
                  </td>
                  <td className="text-right font-weight-bold">
                    {parseToIndoNumber(meta.total_dismantled)}
                  </td>
                  <td className="text-right font-weight-bold">
                    {parseToIndoNumber(meta.total_dismantled_trial)}
                  </td>
                  <td className="text-right font-weight-bold">
                    {parseToIndoNumber(meta.total_reactivated)}
                  </td>
                  <td className="text-right font-weight-bold">{parseToIndoNumber(meta.total)}</td>
                  <td className="text-right font-weight-bold">
                    {parseToIndoNumber(meta.total_homepass)}
                  </td>
                  <td className="text-right font-weight-bold">
                    {convertDecimalToComma(meta.total_occupation_rate)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </Box>
      </div>
    </MainLayout>
  );
}

function ButtonDownloadReport({ filter, onSuccess, onError }) {
  const [loading, setLoading] = useState(false);

  const downloadReport = async () => {
    setLoading(true);
    try {
      let response = await downloadReportCustomerStatus(filter);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Laporan Jumlah Pelanggan per status per site.xlsx`);
      onSuccess(`Berhasil mengunduh Laporan Jumlah Pelanggan per status per site.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      let message = "Something wrong ... ";

      if (error.response) {
        let { data } = error.response;
        let responseObj = await data.text();
        let responseData = JSON.parse(responseObj);
        message = responseData?.message;
      } else {
        message = "Something Error Happened";
      }

      onError(message);
    }

    setLoading(false);
  };

  return (
    <button className="btn btn-primary" onClick={() => downloadReport()} disabled={loading}>
      <i className="fas fa-download"></i> {!loading ? "Unduh Data" : "Harap Tunggu ..."}
    </button>
  );
}
